"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileDeviceSensorFilter = exports.DesktopSensorFilter = exports.SensorFilter = exports.filterCustomSensors = exports.getSensorUnitSymbol = exports.getBasicSensors = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const checkmarkBlue_svg_1 = __importDefault(require("../../../assets/icons/checkmarkBlue.svg"));
const chevronLeft_svg_1 = __importDefault(require("../../../assets/icons/chevronLeft.svg"));
const chevronRight_svg_1 = __importDefault(require("../../../assets/icons/chevronRight.svg"));
const minus_svg_1 = __importDefault(require("../../../assets/icons/minus.svg"));
const plus_svg_1 = __importDefault(require("../../../assets/icons/plus.svg"));
const hooks_1 = require("../../../store/hooks");
const mapSlice_1 = require("../../../store/mapSlice");
const sensorsSlice_1 = require("../../../store/sensorsSlice");
const sessionFiltersSlice_1 = require("../../../store/sessionFiltersSlice");
const filters_1 = require("../../../types/filters");
const sensors_1 = require("../../../types/sensors");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const CustomSensorFilter_1 = require("./CustomSensorFilter");
const FilterInfoPopup_1 = require("./FilterInfoPopup");
const S = __importStar(require("./SessionFilters.style"));
const getBasicSensors = (measurementType, sessionType) => {
    if (measurementType !== filters_1.ParameterTypes.PARTICULATE_MATTER) {
        for (const [key, value] of Object.entries(filters_1.ParameterTypes)) {
            if (value === measurementType) {
                return sensors_1.BasicSensorTypes[key].toString().split(",");
            }
        }
    }
    else {
        if (sessionType === filters_1.SessionTypes.FIXED) {
            return sensors_1.BasicSensorTypes.PARTICULATE_MATTER.FIXED.toString().split(",");
        }
        else if (sessionType === filters_1.SessionTypes.MOBILE) {
            return sensors_1.BasicSensorTypes.PARTICULATE_MATTER.MOBILE.toString().split(",");
        }
    }
};
exports.getBasicSensors = getBasicSensors;
const getSensorUnitSymbol = (selectedSensor, sensors) => {
    const sensor = sensors.find((el) => el.sensorName === selectedSensor);
    return (sensor === null || sensor === void 0 ? void 0 : sensor.unitSymbol) || "";
};
exports.getSensorUnitSymbol = getSensorUnitSymbol;
const filterCustomSensors = (sensors, measurementType, sessionType) => {
    const sensorsForMeasurementType = sensors.filter((sensor) => sensor.measurementType === measurementType);
    const basicSensors = (0, exports.getBasicSensors)(measurementType, sessionType);
    return sensorsForMeasurementType
        .filter((sensor) => !(basicSensors === null || basicSensors === void 0 ? void 0 : basicSensors.includes(sensor.sensorName)))
        .map((sensor) => sensor.sensorName);
};
exports.filterCustomSensors = filterCustomSensors;
const SensorFilter = ({ isBasicOpen }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { sensorName } = (0, mapParamsHandler_1.useMapParams)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const basicSensorsModalOpen = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectBasicSensorsModalOpen);
    const handleShowSensorClick = () => {
        dispatch((0, sessionFiltersSlice_1.setBasicSensorsModalOpen)(!basicSensorsModalOpen));
        dispatch((0, sessionFiltersSlice_1.setBasicParametersModalOpen)(false));
    };
    return (react_1.default.createElement(S.SingleFilterWrapper, null,
        react_1.default.createElement(S.SelectedOptionButton, { onClick: handleShowSensorClick, "$isActive": isBasicOpen },
            react_1.default.createElement(S.SelectedOptionHeadingWrapper, null,
                react_1.default.createElement(S.SelectedOptionHeading, { "$isSelected": isBasicOpen }, t("filters.sensor")),
                react_1.default.createElement(S.SelectedOption, { "$isSelected": isBasicOpen }, sensorName)),
            react_1.default.createElement(S.ChevronIcon, { "$src": chevronRight_svg_1.default, "$isActive": isBasicOpen })),
        react_1.default.createElement(FilterInfoPopup_1.FilterInfoPopup, { filterTranslationLabel: "filters.sensorInfo" })));
};
exports.SensorFilter = SensorFilter;
const DesktopSensorFilter = () => {
    const [isBasicOpen, setIsBasicOpen] = (0, react_1.useState)(false);
    const [moreOpen, setMoreOpen] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const { measurementType, sessionType, sensorName, setSensorParams } = (0, mapParamsHandler_1.useMapParams)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const sensors = (0, hooks_1.useAppSelector)(sensorsSlice_1.selectSensors);
    const basicSensorsModalOpen = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectBasicSensorsModalOpen);
    const customSensorsModalOpen = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectCustomSensorsModalOpen);
    const customSensors = (0, exports.filterCustomSensors)(sensors, measurementType, sessionType);
    const basicSensors = (0, exports.getBasicSensors)(measurementType, sessionType);
    const handleSelectSensor = (selectedSensor) => {
        setSensorParams(selectedSensor, sensors);
        dispatch((0, sessionFiltersSlice_1.setBasicSensorsModalOpen)(false));
        dispatch((0, mapSlice_1.setFetchingData)(true));
    };
    (0, react_1.useEffect)(() => {
        setIsBasicOpen(basicSensorsModalOpen);
        setMoreOpen(customSensorsModalOpen);
    }, [basicSensorsModalOpen, customSensorsModalOpen]);
    return (react_1.default.createElement(S.Wrapper, null,
        react_1.default.createElement(exports.SensorFilter, { isBasicOpen: isBasicOpen }),
        !isMobile && isBasicOpen && (react_1.default.createElement(S.FiltersOptionsWrapper, null,
            react_1.default.createElement(S.BasicParameterWrapper, null,
                react_1.default.createElement(S.FiltersOptionHeading, null, t("filters.sensor")), basicSensors === null || basicSensors === void 0 ? void 0 :
                basicSensors.map((item, id) => (react_1.default.createElement(S.FiltersOptionButton, { onClick: () => handleSelectSensor(item), "$isSelected": item === sensorName, key: id }, item))),
                customSensors.length > 0 && (react_1.default.createElement(S.SeeMoreButton, { onClick: () => setMoreOpen(!moreOpen) },
                    react_1.default.createElement(S.SeeMoreSpan, null, t(`filters.${moreOpen ? "seeLess" : "seeMore"}`)),
                    react_1.default.createElement("img", { src: moreOpen ? minus_svg_1.default : plus_svg_1.default, alt: "" })))),
            moreOpen && react_1.default.createElement(CustomSensorFilter_1.CustomSensorFilter, { customSensors: customSensors })))));
};
exports.DesktopSensorFilter = DesktopSensorFilter;
const MobileDeviceSensorFilter = ({ customSensors, sessionsCount, onClose, fetchableSessionsCount, }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { measurementType, sessionType, sensorName, currentUserSettings, isIndoor, setSensorParams, } = (0, mapParamsHandler_1.useMapParams)();
    const sensors = (0, hooks_1.useAppSelector)(sensorsSlice_1.selectSensors);
    const basicSensors = (0, exports.getBasicSensors)(measurementType, sessionType);
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const handleSelectSensor = (0, react_1.useCallback)((selectedSensor) => {
        setSensorParams(selectedSensor, sensors);
        dispatch((0, sessionFiltersSlice_1.setBasicSensorsModalOpen)(false));
        dispatch((0, mapSlice_1.setFetchingData)(true));
    }, [
        sensors,
        isMobile,
        currentUserSettings,
        isIndoor,
        setSensorParams,
        dispatch,
    ]);
    const handleShowMoreClick = () => {
        dispatch((0, sessionFiltersSlice_1.setBasicSensorsModalOpen)(false));
        dispatch((0, sessionFiltersSlice_1.setCustomSensorsModalOpen)(true));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.ModalContent, null,
            react_1.default.createElement(S.Header, null,
                react_1.default.createElement(S.ChevronBackButton, { onClick: () => dispatch((0, sessionFiltersSlice_1.setBasicSensorsModalOpen)(false)) },
                    react_1.default.createElement("img", { src: chevronLeft_svg_1.default, alt: t("filters.back") })),
                react_1.default.createElement(S.HeaderTitle, null, t("filters.selectSensor"))),
            react_1.default.createElement(S.Description, null, t("filters.selectSensorsDescription")),
            react_1.default.createElement(S.BasicParameterButtonsWrapper, null, basicSensors === null || basicSensors === void 0 ? void 0 : basicSensors.map((item, id) => (react_1.default.createElement(S.BasicParameterButton, { key: id, onClick: () => handleSelectSensor(item) },
                react_1.default.createElement(S.ButtonSpan, { "$isActive": item === sensorName }, item),
                item === sensorName && (react_1.default.createElement("img", { src: checkmarkBlue_svg_1.default, alt: t("filters.altCheckmark") })))))),
            customSensors.length > 0 && (react_1.default.createElement(S.GrayButton, { onClick: handleShowMoreClick }, t("filters.showCustomSensors")))),
        react_1.default.createElement(S.ButtonsWrapper, null,
            react_1.default.createElement(S.BackButton, { onClick: () => dispatch((0, sessionFiltersSlice_1.setBasicSensorsModalOpen)(false)) }, t("filters.back")),
            react_1.default.createElement(S.MinorShowSessionsButton, { onClick: onClose }, sessionType === filters_1.SessionTypes.FIXED ? (react_1.default.createElement(react_1.default.Fragment, null,
                t("filters.showSessions"),
                " (",
                sessionsCount,
                ")")) : (react_1.default.createElement(react_1.default.Fragment, null,
                t("filters.showSessions"),
                " ",
                t("map.results", {
                    results: sessionsCount,
                    fetchableSessionsCount,
                })))))));
};
exports.MobileDeviceSensorFilter = MobileDeviceSensorFilter;
